import React from 'react';
import {useGlobalContext} from "../../contexts/GlobalContext";
import classnames from "classnames";
import styles from "./styles.module.scss";
import themeStyles from "../../styles/theme.module.scss";

type Line = {
  showMarkNecessary?: boolean;
  label: string
}
type Props = {
  headerCells: Line[];
  customStyles?: string
}

const CommonGridHeader = ({headerCells = [], customStyles = ''}: Props) => {
  const {isGlassTheme} = useGlobalContext();

  const mapHeaderCells = (item: Line, index: number) => {
    return (
      <div key={index} className={classnames(styles.headerCell)}>
        {item.label}
        {item.showMarkNecessary && <span className="text-danger">*</span>}
      </div>
    );
  };
  return (
    <div className={classnames(styles.header,
      isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
      isGlassTheme ? themeStyles.primaryBackground : themeStyles.usualBackground,
      customStyles
    )}>
      {headerCells.map(mapHeaderCells)}
    </div>
  );
};

export default CommonGridHeader;
